export function initAnimationObserver(elements, animationClass, options = {}) {
  const {
    rootMargin = '-100px',
    threshold = 0.1,
    stagger = false,
    staggerDelay = 150,
    initialDelay = 0,
  } = options;

  if (!elements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate__animated', animationClass);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin, threshold });

  elements.forEach((el, i) => {
    const delay = stagger
      ? initialDelay + i * staggerDelay
      : initialDelay;
    el.style.setProperty('--animate-delay', `${delay}ms`);
    observer.observe(el);
  });
}